/**
 * Теги кешу налаштувань простору (GET /workspaces/{id}/settings): тег налаштувань простору; зміна «Розміщення полів» (fieldLayout) ще й
 * перечитує глобальний каталог — він рахує простори з власним розміщенням полів («N з власним розміщенням полів»). Чиста функція.
 */
export function workspaceSettingTags(ws: string, key?: string) {
  const own = { type: 'Settings' as const, id: `ws:${ws}` };
  return key === 'fieldLayout' ? [own, 'GlobalCatalog' as const] : [own];
}
